// extracted by mini-css-extract-plugin
export var auto = "_3l-1";
export var spinner = "_3l-0";